<template>
  <section class="wrapper">
    <app-header :user="auth_user"></app-header>
    <app-sidebar @openUpload="prepareUpload()"></app-sidebar>
    <!-- Content Wrapper -->
    <div class="content-wrapper bg-white">
      <label class="no-print" style="font-size: 14px;margin-left:15px"> {{auth_user.empresa.empresa_nome}} |
      </label>
      <bread-crumb class="no-print"></bread-crumb>
      <auto-logout></auto-logout>
      <tags-view class="no-print"></tags-view>
      <app-main></app-main>
      <m-logout></m-logout>
      <m-upload :folder="folders" @refreshFiles="fetchFiles" ref="mUpload"></m-upload>
    </div>
    <app-footer class="no-print pt-5 bg-white"></app-footer>
    <!-- Add the sidebar's background. This div must be placed
		immediately after the control sidebar -->
    <div class="control-sidebar-bg"></div>
  </section>
</template>
<script>
  import AppHeader from './partials/Header.vue';
  import AppSidebar from './partials/Sidebar.vue';
  import AppFooter from './partials/Footer.vue';
  import AppMain from './AppMain.vue';
  import TagsView from '../components/TagsView.vue';
  import BreadCrumb from '../components/BreadCrumb.vue';
  import mUpload from '../components/file-upload/m-upload.vue';
  import fileOperations from './dashboard/functions/fileOperations';
  import AutoLogout from '../components/AutoLogout.vue';
  import mLogout from '../components/m-logout.vue';
  export default {
    name: 'Layout',
    components: {
      AppHeader,
      AppSidebar,
      AppFooter,
      AppMain,
      TagsView,
      BreadCrumb,
      mUpload,
      AutoLogout,
      mLogout
    },
    beforeMount() {
      this.$store.dispatch('getUserData');
      this.changeLayout();
      this.fetchFiles = fileOperations.fetchFiles.bind(this);
    },
    computed: {
      id() {
        return this.$store.state.user.id;
      },
      folders() {
        return this.$store.state.user.data.folders;
      },
    },
    watch: {
      id: function () {
        this.changeLayout();
      }
    },
    methods: {
      prepareUpload() {
        this.$refs.mUpload.showModal();
      },
      changeLayout() {
        this.$root.$i18n.locale = this.$store.state.user.localSettings.user_language;
        this.$root.$validator.locale = this.$store.state.user.localSettings.user_language;
        this.getLayout();
      },
    }
  };
</script>
<style>
  .grecaptcha-badge {
    visibility: hidden;
  }
</style>